<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">
    <div class="title_sub_div_1 title_right_icon_div">Analysis</div>
    <div class="title_sub_div_1 mt-1 mr-1">
      <i class="fa fa-refresh" (click)="refresh()" [class.rotating]="isRefreshing" title="Refresh"
        [ngClass]="{'disabled': isRefreshing}" [style.opacity]="isRefreshing ? '0.6' : '1'"></i>
      <i class="fa fa-home" style="margin-left: 10px;" (click)="home()" title="Dashboard"></i>
    </div>
  </div>
</div>

<div class="dashboard-container">
  <!-- TOP SECTION: Metrics and Filters -->
  <div class="top-section">
    <!-- TOP METRICS ROW -->
    <div class="metrics-row">
      <div class="metric-card metric-card-blue" (click)="navigateToAllProjects()" style="cursor: pointer;">
        <div class="metric-content">
          <div class="metric-text-block">
            <div class="metric-value">{{ metrics.projects }}</div>
            <div class="metric-label">number of projects</div>
          </div>
        </div>
        <div class="metric-icon-right">
          <i class="fa fa-line-chart"></i>
        </div>
      </div>
      <div class="metric-card metric-card-green">
        <div class="metric-content">
          <div class="metric-text-block">
            <div class="metric-value">{{ metrics.parts }}</div>
            <div class="metric-label">number of parts</div>
          </div>
        </div>
        <div class="metric-icon-right">
          <i class="fa fa-bar-chart"></i>
        </div>
      </div>
      <div class="metric-card metric-card-purple" (click)="navigateToOpenProjects()" style="cursor: pointer;">
        <div class="metric-content">
          <div class="metric-text-block">
            <div class="metric-value">{{ metrics.openProjects }}</div>
            <div class="metric-label">Open projects</div>
          </div>
        </div>
        <div class="metric-icon-right">
          <i class="fa fa-tasks"></i>
        </div>
      </div>
      <div class="metric-card metric-card-orange">
        <div class="metric-content">
          <div class="metric-text-block">
            <div class="metric-value">{{ metrics.totalValue }}</div>
            <div class="metric-label">Total sourced value</div>
          </div>
        </div>
        <div class="metric-icon-right">
          <i class="fa fa-inr"></i>
        </div>
      </div>
    </div>

    <!-- Filters & Customer (Right Top) -->
    <div class="filters-section">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Date filter">Date filter</button>
      <button type="button" class="btn btn-outline-primary btn-sm " title="Customer">Customer</button>
    </div>
  </div>

  <!-- CHARTS ROW 1 -->
  <div class="charts-row">
    <!-- Ageing Chart -->
    <div class="chart-box ageing-chart">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 style="margin: 0;">Ageing</h4>
        <button class="btn btn-sm btn-light" title="Filter by date" (click)="toggleAgeingDateFilter()">
          📅
        </button>
      </div>
      <div *ngIf="showAgeingDateFilter" class="date-filter-row mb-2">
        <input type="date" [(ngModel)]="ageingStartDate" class="form-control form-control-sm" placeholder="Start Date">
        <input type="date" [(ngModel)]="ageingEndDate" class="form-control form-control-sm" placeholder="End Date">
        <button class="btn btn-sm btn-primary" (click)="loadAgeingSummary({})">
          Apply
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelAgeingDateFilter()">
          Cancel
        </button>
      </div>
      <canvas baseChart [datasets]="ageingChartData.datasets" [labels]="ageingChartData.labels" [options]="chartOptions"
        [legend]="chartLegend" type="bar"></canvas>
    </div>

    <!-- Completion Chart -->
    <div class="chart-box completion-chart">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 style="margin: 0;">% completion</h4>
        <button class="btn btn-sm btn-light" title="Filter by date" (click)="toggleCompletionDateFilter()">
          📅
        </button>
      </div>
      <div *ngIf="showCompletionDateFilter" class="date-filter-row mb-2">
        <input type="date" [(ngModel)]="completionStartDate" class="form-control form-control-sm" placeholder="Start Date">
        <input type="date" [(ngModel)]="completionEndDate" class="form-control form-control-sm" placeholder="End Date">
        <button class="btn btn-sm btn-primary" (click)="loadCompletionSummary()">
          Apply
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelCompletionDateFilter()">
          Cancel
        </button>
      </div>
      <canvas #completionChart baseChart [datasets]="completionChartData.datasets" [labels]="completionChartData.labels"
        [options]="chartOptionsNoGrid" [legend]="chartLegend" (chartClick)="onCompletionChartClick($event)" type="doughnut" style="cursor: pointer;"></canvas>
      <p style="text-align:center;font-size:12px;color:#999;margin-top:8px;">
        Click on a segment to filter projects
      </p>
    </div>
  </div>

  <!-- CHARTS ROW 2 -->
  <div class="charts-row">
    <!-- Smart Sync Summary -->
    <div class="summary-box">
      <h4>Smart Sync Summary</h4>

      <div class="summary-grid">
        <div class="summary-item">
          <div class="summary-value">
            {{ smartSyncSummary?.year_count }}
          </div>
          <div class="summary-label">This year</div>
        </div>

        <div class="summary-item">
          <div class="summary-value">
            {{ smartSyncSummary?.month_count }}
          </div>
          <div class="summary-label">This month</div>
        </div>

        <div class="summary-item">
          <div class="summary-value">
            {{ smartSyncSummary?.year_costSaving }}
          </div>
          <div class="summary-label">This year</div>
        </div>

        <div class="summary-item">
          <div class="summary-value">
            {{ smartSyncSummary?.month_costSaving }}
          </div>
          <div class="summary-label">This month</div>
        </div>
      </div>
      <!-- <table class="custom-hover summary-table">
        <thead>
          <tr>
            <th>Consol ID</th>
            <th>Cost savings</th>
    
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of costSavingsList">
            <td>{{ row.Consol_ID }}</td>
            <td>{{ row.Cost_savings | number:'1.2-2' }}</td>
      
          </tr>
        </tbody>
      </table>
      <div style="margin-top: 10px;">
        <table class="custom-hover summary-table">
          <thead>
            <tr>

              <th>Consol ID</th>
              <th>Quantity save</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of costSavingsList">

              <td>{{ row.Consol_ID }}</td>
              <td>{{ row.Qty }}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
    <div class="row">
  <div class="col-md-12">
    <table class="custom-hover summary-table w-100">
      <thead>
        <tr>
          <th>Consol ID</th>
          <th>Cost savings</th>
           <th>MPN</th>
            <th>Quantity</th>
            <th>Created Date </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of costSavingsList">
          <td>{{ row.Consol_ID }}</td>
          <td>{{ row.Cost_savings | number:'1.2-2' }}</td>
          <td>{{ row.MPN }}</td>
           <td>{{ row.Qty | number:'1.2-2' }}</td>
            <td>{{ row.createdDate  }}</td>
        </tr>
      </tbody>
    </table>
  </div>


</div>
    </div>

    <!-- Cost Chart - Horizontal Bar Chart -->
    <div class="chart-box cost-chart chart-wrapper" style="min-height: 350px;">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 style="margin: 0;">Payment Terms Distribution </h4>
        <button class="btn btn-sm btn-light" title="Filter by date" (click)="toggleCostDateFilter()">
          📅
        </button>
      </div>
      <div *ngIf="showCostDateFilter" class="date-filter-row mb-2">
        <input type="date" [(ngModel)]="costStartDate" class="form-control form-control-sm" placeholder="Start Date">
        <input type="date" [(ngModel)]="costEndDate" class="form-control form-control-sm" placeholder="End Date">
        <button class="btn btn-sm btn-primary" (click)="loadDashboards({})">
          Apply
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelCostDateFilter()">
          Cancel
        </button>
      </div>
      <canvas baseChart [datasets]="costChartData.datasets" [labels]="costChartData.labels" [options]="paymentTermsChartOptions"
        type="bar" style="position: relative; height: 300px;"></canvas>
    </div>

    <!-- Engineer-wise Chart -->
    <div class="chart-box engineer-chart">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 style="margin: 0;">Engineer-wise</h4>
        <button class="btn btn-sm btn-light" title="Filter by date" (click)="toggleEngineerDateFilter()">
          📅
        </button>
      </div>
      <div *ngIf="showEngineerDateFilter" class="date-filter-row mb-2">
        <input type="date" [(ngModel)]="engineerStartDate" class="form-control form-control-sm" placeholder="Start Date">
        <input type="date" [(ngModel)]="engineerEndDate" class="form-control form-control-sm" placeholder="End Date">
        <button class="btn btn-sm btn-primary" (click)="loadDashboards({})">
          Apply
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelEngineerDateFilter()">
          Cancel
        </button>
      </div>
      <canvas baseChart [datasets]="engineerChartData.datasets" [labels]="engineerChartData.labels"
        [options]="chartOptions" [legend]="chartLegend" type="bar"></canvas>
    </div>
 <div class="master-data-box">
        <h4>Master data type</h4>

        <table class="custom-hover master-data-table">
          <thead>
            <tr>
              <th>Type</th>
              <th style="text-align: right;">Last Updated</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of masterDataStatusList">
              <td>{{ row.type }}</td>
              <td style="text-align: right;">
                {{ row.last_updated_days }} Days
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
  <!-- <div class="chart-box import-status">
    <h4>Import status</h4>
    <canvas baseChart [datasets]="importStatusData.datasets" [labels]="importStatusData.labels" [options]="chartOptions"
      [legend]="chartLegend" type="bar"></canvas>
  </div> -->

  <!-- CHARTS ROW 3: Two Partitions -->
  <div class="two-tables-wrapper">
    <!-- Top 5 Suppliers -->
    <div class="master-data-box">
      <div class="d-flex align-items-center justify-content-between">
        <h4 style="margin:0">Top 5 Suppliers</h4>
        <button
          class="btn btn-sm btn-supplier"
          title="Top vendors"
          (click)="toggleTopVendorFilter()">
          🔽
        </button>
      </div>
 
      <div *ngIf="showTopVendorFilter" class="mb-2" style="max-width:120px">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="selectedTopN"
          (change)="loadMasterData()">
          <option [ngValue]="5">Top 5</option>
          <option [ngValue]="10">Top 10</option>
          <option [ngValue]="20">Top 20</option>
        </select>
      </div>

      <table class="custom-hover master-data-table">
        <thead>
          <tr>
            <th>Supplier</th>
            <th style="text-align:right">Total Value</th>
            <th style="text-align:right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of masterDataDisplayList">
            <td><span style="cursor: pointer; color: #0066cc; text-decoration: underline;" title="Supplier data">{{ row.supplier }}</span></td>
            <td style="text-align:right">
              {{ row.total_value | number:'1.0-0' }}
            </td>
            <td style="text-align:right">
              {{ row.count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Part Deviation -->
    <div class="part-deviation-box">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 style="margin:0">Part Deviation (INR)</h4>
        <div class="d-flex gap-2" style="gap: 8px;">
        
          <button
            class="btn btn-sm btn-deviation"
            title="Top records"
            (click)="togglePartDeviationTopFilter()">
            🔽
          </button>
        </div>
      </div>

      <div *ngIf="showPartDeviationDateFilter" class="date-filter-row mb-2">
        <input type="date" [(ngModel)]="partDeviationStartDate" class="form-control form-control-sm" placeholder="Start Date">
        <input type="date" [(ngModel)]="partDeviationEndDate" class="form-control form-control-sm" placeholder="End Date">
        <button class="btn btn-sm btn-primary" (click)="loadPartPricingSummary()">
          Apply
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="cancelPartDeviationDateFilter()">
          Cancel
        </button>
      </div>
      
      <div *ngIf="showPartDeviationTopFilter" class="mb-2" style="max-width:120px">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="selectedPartDeviationTopN"
          (change)="loadPartPricingSummary()">
          <option [ngValue]="5">Top 5</option>
          <option [ngValue]="10">Top 10</option>
          <option [ngValue]="20">Top 20</option>
        </select>
      </div>

      <table class="part-table">
        <thead>
          <tr>
            <th>Part</th>
            <th>Deviation (INR)</th>
            <th>Considered</th>
            <th>Minimum Price</th>
            <th>Minimum Price PO</th>
            <th>Project Id</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of partDeviationDisplayList">
            <td class="part-link" (click)="navigateToPartInProjectView($event, row.internalPartNo)" style="cursor: pointer; color: #0066cc; text-decoration: underline;" title="Click to view this part in project-view">{{ row.internalPartNo }}</td>
            <td>{{ row.deviation | number:'1.0-2' }}</td>
            <td>{{ row.considered | number:'1.0-2' }}</td>
            <td>{{ row.minimumPrice | number:'1.0-2' }}</td>
            <td>
              {{
              row.minimumPriceFromPO === 'NA'
              ? 'NA'
              : (row.minimumPriceFromPO | number:'1.0-2')
              }}
            </td>
            <td>{{ row.project_id }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>